document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('.warranty-form__form');
  if (!form) return;

  var requiredTextInputs = form.querySelectorAll('input[type="text"][required]');
  if (!requiredTextInputs.length) return;

  function setError(input, message) {
    var field = input.closest('.warranty-form__field');
    var existing = field.querySelector('.warranty-form__field-error');
    if (existing) {
      existing.remove();
    }

    if (!message) {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
      return;
    }

    var errorId = input.id + '-error';
    var errorEl = document.createElement('span');
    errorEl.className = 'warranty-form__field-error';
    errorEl.id = errorId;
    errorEl.setAttribute('role', 'alert');
    errorEl.textContent = message;
    field.appendChild(errorEl);
    input.setAttribute('aria-invalid', 'true');
    input.setAttribute('aria-describedby', errorId);
  }

  function getError(input) {
    if (input.value.trim() === '') {
      return 'This field cannot be blank';
    }
    return null;
  }
  document.addEventListener(
    'submit',
    function (event) {
      if (event.target !== form) return;

      var results = [];
      var isValid = true;

      requiredTextInputs.forEach(function (input) {
        var error = getError(input);
        if (error) {
          isValid = false;
        }
        results.push({ input: input, error: error });
      });

      if (!isValid) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }

      results.forEach(function (result) {
        try {
          setError(result.input, result.error);
        } catch (e) {
          console.error('warranty-form: failed to render field error', e);
        }
      });
    },
    true
  );

  requiredTextInputs.forEach(function (input) {
    input.addEventListener('input', function () {
      if (input.getAttribute('aria-invalid') === 'true' && !getError(input)) {
        setError(input, null);
      }
    });
  });
});
